module.exports = __webpack_public_path__ + "static/media/what_is_ReciBASE_banner.2f726883.jpg";